<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Sewing Records List
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goToCreate"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi-plus"
                        rounded="xl"
                      >
                        Create Sewing Input
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="pt-0">
                  <v-col cols="12">
                    <div class="scrollable-table-wrapper">
                      <v-data-table
                        :headers="headers"
                        :items="sewingInputList"
                        :loading="loading"
                        v-model:items-per-page="itemsPerPage"
                        :search="search"
                        :hover="true"
                        density="compact"
                        class="responsive-table"
                      >
                        <template v-slot:item.index="{ index }">
                          {{ ++index }}
                        </template>

                        <template v-slot:item.code="{ item }">
                          {{ item.code }}
                        </template>

                        <template v-slot:item.po="{ item }">
                          {{ item.po?.code || "-" }}
                        </template>

                        <template v-slot:item.style="{ item }">
                          {{ item.po?.style?.code || "-" }}
                        </template>

                        <template v-slot:item.cutting_date="{ item }">
                          {{ formatDateView(item.cutting_date) }}
                        </template>

                        <template v-slot:item.total_qty="{ item }">
                          {{ calculateTotalQty(item.details) }}
                        </template>

                        <template v-slot:item.status="{ item }">
                          <v-chip
                            size="small"
                            :color="item.status == 1 ? 'success' : 'red'"
                          >
                            {{ item.status == 1 ? "Active" : "Inactive" }}
                          </v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                          <div class="d-flex align-center justify-center" style="gap: 6px;">
                            <v-tooltip text="Edit">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  v-bind="props"
                                  icon="mdi-pencil"
                                  size="small"
                                  variant="text"
                                  color="primary"
                                  @click="goToEdit(item.id)"
                                  v-if="$updateAccess($route.fullPath)"
                                />
                              </template>
                            </v-tooltip>
                            <v-tooltip text="View Details">
                              <template v-slot:activator="{ props }">
                                <v-btn
                                  v-bind="props"
                                  icon="mdi-eye"
                                  size="small"
                                  variant="text"
                                  color="info"
                                  @click="viewDetails(item)"
                                  v-if="$viewAccess($route.fullPath)"
                                />
                              </template>
                            </v-tooltip>
                          </div>
                        </template>

                        <template v-slot:no-data>
                          <div class="text-center py-4">
                            <p>No cutting records found</p>
                          </div>
                        </template>
                      </v-data-table>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- Details Dialog -->
    <v-dialog v-model="detailsDialog" max-width="800px">
      <v-card>
        <v-card-title class="bg-blue-grey-lighten-4">
          Cutting Details - {{ selectedItem?.code }}
        </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="6">
              <strong>PO Code:</strong> {{ selectedItem?.po?.code || "-" }}
            </v-col>
            <v-col cols="6">
              <strong>Style:</strong> {{ selectedItem?.po?.style?.code || "-" }}
            </v-col>
            <v-col cols="6">
              <strong>Cutting Date:</strong>
              {{ formatDateView(selectedItem?.cutting_date) }}
            </v-col>
            <v-col cols="6">
              <strong>Status:</strong>
              <v-chip
                size="small"
                :color="selectedItem?.status == 1 ? 'success' : 'red'"
                class="ml-2"
              >
                {{ selectedItem?.status == 1 ? "Active" : "Inactive" }}
              </v-chip>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <h3 class="mb-3">Cutting Details</h3>
          <v-table density="compact">
            <thead>
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">Color</th>
                <th class="text-left">Size</th>
                <th class="text-right">Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(detail, index) in selectedItem?.details || []"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ detail.color?.name || "-" }}</td>
                <td>{{ detail.size?.name || "-" }}</td>
                <td class="text-right">{{ detail.qty || 0 }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="outlined"
           
            prepend-icon="mdi-pencil"
            v-if="$updateAccess($route.fullPath)"
          >
            Edit
          </v-btn>
          <v-btn color="primary" variant="tonal" @click="detailsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { ref } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { formatDateView, formatDateDash } from "@/plugins/helpers";

export default {
  name: "CuttingRecords",
  
  data() {
    return {
      panel: [0],
      loading: false,
      search: "",
      itemsPerPage: 10,
      detailsDialog: false,
      selectedItem: null,
      headers: [
        {
          title: "#SL",
          align: "center",
          key: "index",
          width: "80px",
          sortable: false,
        },
        {
          title: "Code",
          key: "code",
          align: "left",
          sortable: true,
        },
        {
          title: "PO Code",
          key: "po.code",
          align: "left",
          sortable: false,
        },
       
        {
          title: "Sewing Date",
          key: "sewing_date",
          align: "left",
          sortable: true,
        },
        {
          title: "Line",
          key: "line",
          align: "left",
          sortable: true,
        },
        {
          title: "Status",
          key: "status",
          align: "center",
          sortable: true,
        },
        {
          title: "Actions",
          key: "actions",
          align: "center",
          sortable: false,
          width: "120px",
        },
      ],
    };
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable(),
        to_date: yup.date().nullable(),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");

    const submit = handleSubmit((values) => {
      // Implement search logic if needed
      store.dispatch("getProductionSewingInputList");
    });

    const goToCreate = () => {
      router.push("/bhp/sewing/input");
    };

    const goToEdit = (id) => {
      router.push(`/bhp/sewing/input/${id}`);
    };

    const exportToCSV = () => {
      toast.info("CSV export functionality to be implemented");
    };

    const exportToExcel = () => {
      toast.info("Excel export functionality to be implemented");
    };

    const exportToPDF = () => {
      toast.info("PDF export functionality to be implemented");
    };

    return {
      from_date,
      to_date,
      submit,
      goToCreate,
      goToEdit,
      exportToCSV,
      exportToExcel,
      exportToPDF,
    };
  },

  computed: {
    sewingInputList() {
      return this.$store.getters.getProductionSewingInputList || [];
    },
  },

  methods: {
    loadList() {
      this.loading = true;
      this.$store.dispatch("getProductionSewingInputList").finally(() => {
        this.loading = false;
      });
    },
    viewDetails(item) {
      this.$router.push({ name: "sewing-input-view", params: { id: item.id } });
      // Fetch full details from backend to ensure all relationships are loaded
    //   this.loading = true;
    //   this.$store
    //     .dispatch("getProductionCuttingById", item.id)
    //     .then((response) => {
    //       this.selectedItem = response.data.data;
    //       this.detailsDialog = true;
    //     })
    //     .catch((err) => {
    //       toast.error(err.response?.data?.message || "Failed to load details");
    //       // Fallback to using item from list if API call fails
    //       this.selectedItem = item;
    //       this.detailsDialog = true;
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    },

    calculateTotalQty(details) {
      if (!details || !Array.isArray(details)) return 0;
      return details.reduce((sum, detail) => sum + (parseInt(detail.qty) || 0), 0);
    },
  },

  created() {
    this.loadList();
  },
};
</script>

<style scoped>
.scrollable-table-wrapper {
  overflow-x: auto;
}

.responsive-table {
  min-width: 100%;
}
</style>
